import { render, staticRenderFns } from "./carousel3d.vue?vue&type=template&id=13ba2cbc"
import script from "./carousel3d.vue?vue&type=script&lang=js"
export * from "./carousel3d.vue?vue&type=script&lang=js"
import style0 from "./carousel3d.vue?vue&type=style&index=0&id=13ba2cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports